module.exports = __webpack_public_path__ + "img/DerVorhangGehtAuf.247e7001.jpg";